import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Step from "@mui/material/Step";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { styled } from "@mui/material/styles";
import { ReactElement } from "react";
import { Col, Row } from "react-bootstrap";
interface IProps {
  steps: {
    label: string | ReactElement;
    completed: boolean;
    processing: boolean;
  }[];
}

const CustomStepper = (props: IProps) => {
  const { steps } = props;

  const CustomStep = styled("div")<{
    state: { completed: boolean; processing: boolean };
  }>(({ state }) => ({
    backgroundColor: "white",
    zIndex: 1,
    color: "#fff",
    width: 70,
    height: 70,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    border: "6px solid #90cea5",
    ...(state.completed && {
      backgroundColor: "#2DB573",
      border: 0,
    }),
    ...(state.processing && {
      backgroundColor: "#FF0000",
      border: 0,
    }),
  }));

  const Connector = styled(StepConnector)(() => ({
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor: "#2DB573",
      transform: "translate(30px, 20px)",
      width: "70%",
    },
  }));

  return (
    <Row className="py-3" style={{ overflowX: "auto" }}>
      <Col>
        <Stepper alternativeLabel connector={<Connector />}>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepLabel
                StepIconComponent={() => (
                  <CustomStep
                    state={{
                      processing: step.processing,
                      completed: step.completed,
                    }}
                  >
                    {step.completed && (
                      <FontAwesomeIcon size="2x" icon={faCheck} color="white" />
                    )}
                  </CustomStep>
                )}
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Col>
    </Row>
  );
};

export default CustomStepper;
